<div [formGroup]="treeviewContainerForm">
  <kendo-textbox #filterBox
                 formControlName="filterBox"
                 placeholder="Find in filters..."
                 [value]="filterValue"
                 (inputBlur)="onFilterInputBlur()"
                 (inputFocus)="onFilterInputFocus()"
                 (valueChange)="onFilterChange($event)">
  </kendo-textbox>
</div>
<div class="criteria">
  <ng-content></ng-content>
</div>
